import { render, staticRenderFns } from "./OptionBase.vue?vue&type=template&id=6592c9f6&scoped=true&lang=pug"
import script from "./OptionBase.vue?vue&type=script&lang=ts"
export * from "./OptionBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592c9f6",
  null
  
)

export default component.exports